(() => {
  const rulesNode = document.getElementById('FctStickerBundleRules');
  if (!rulesNode || window.fctStickerBundles) return;
  const rules = JSON.parse(rulesNode.textContent);
  const nativeFetch = window.fetch.bind(window);
  const root = (rules.root || '/').replace(/\/?$/, '/');
  const variantSets = Object.fromEntries(['mini', 'bumper'].map(type => [type, new Set(rules[type].variantIds.map(String))]));
  const ownedCodes = new Set(['mini', 'bumper'].flatMap(type => [...rules[type].tiers.map(tier => tier.code), ...(rules[type].retiredCodes || [])]).map(code => code.toLowerCase()));
  let pending = Promise.resolve();
  let lastCart = null;

  const getJSON = async (path, options) => {
    const response = await nativeFetch(root + path, { credentials: 'same-origin', ...options });
    if (!response.ok) throw new Error('Could not update sticker bundle pricing');
    return response.json();
  };

  const desiredCodes = cart => {
    const codes = (cart.discount_codes || []).map(item => item.code).filter(code => code && !ownedCodes.has(code.toLowerCase()));
    for (const type of ['mini', 'bumper']) {
      const count = (cart.items || []).reduce((total, item) => total + (!item.selling_plan_allocation && variantSets[type].has(String(item.variant_id || item.id)) ? item.quantity : 0), 0);
      if (count >= 3) codes.push(rules[type].tiers[0].code);
    }
    return [...new Map(codes.map(code => [code.toLowerCase(), code])).values()];
  };

  const sync = async () => {
    let cart = await getJSON('cart.js');
    for (const item of cart.items || []) {
      if (!['mini', 'bumper'].some(type => variantSets[type].has(String(item.variant_id || item.id))) || !item.properties?.__kaching_bundles) continue;
      const properties = Object.fromEntries(Object.entries(item.properties).filter(([key]) => !key.startsWith('__kaching_')));
      cart = await getJSON('cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: item.key, quantity: item.quantity, properties }) });
    }
    const codes = desiredCodes(cart);
    const current = (cart.discount_codes || []).map(item => item.code.toLowerCase()).sort();
    if (JSON.stringify(current) !== JSON.stringify(codes.map(code => code.toLowerCase()).sort())) {
      cart = await getJSON('cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: codes.join(',') }) });
    }
    lastCart = cart;
    document.querySelectorAll('[data-fct-cart-count]').forEach(badge => { badge.textContent = String(cart.item_count); });
    document.dispatchEvent(new CustomEvent('fct:bundles:updated', { detail: { cart } }));
    return cart;
  };

  const reconcile = () => {
    pending = pending.catch(() => {}).then(sync);
    return pending;
  };

  window.fetch = async (input, options) => {
    const response = await nativeFetch(input, options);
    let url;
    try { url = new URL(typeof input === 'string' || input instanceof URL ? input : input.url, location.origin); }
    catch { return response; }
    if (!response.ok || url.origin !== location.origin || !/\/cart\/(add|change|update|clear)(\.js)?\/?$/.test(url.pathname)) return response;
    try {
      let cart = await reconcile();
      let original;
      try { original = await response.clone().json(); } catch {}
      if (original?.sections) {
        cart = await getJSON('cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: {}, sections: Object.keys(original.sections) }) });
        if (/\/cart\/add/.test(url.pathname)) original.sections = cart.sections;
      }
      if (!/\/cart\/add/.test(url.pathname)) {
        const headers = new Headers(response.headers);
        headers.delete('content-length');
        headers.delete('content-encoding');
        headers.set('content-type', 'application/json');
        return new Response(JSON.stringify(cart), { status: response.status, headers });
      }
      if (original?.sections) {
        const headers = new Headers(response.headers);
        headers.delete('content-length');
        headers.delete('content-encoding');
        return new Response(JSON.stringify(original), { status: response.status, headers });
      }
    } catch (error) {
      document.dispatchEvent(new CustomEvent('fct:bundles:error', { detail: { error } }));
    }
    return response;
  };

  window.fctStickerBundles = { reconcile, desiredCodes, get cart() { return lastCart; } };
  window.addEventListener('pageshow', () => reconcile().catch(() => {}));
  let debounce;
  if (window.PerformanceObserver?.supportedEntryTypes?.includes('resource')) {
    new PerformanceObserver(list => {
      if (!list.getEntries().some(entry => /\/cart\/(add|change|clear)(\.js)?(?:\?|$)/.test(entry.name))) return;
      clearTimeout(debounce);
      debounce = setTimeout(() => reconcile().then(() => {
        if (typeof window.monster_refresh === 'function') window.monster_refresh(false);
      }).catch(() => {}), 100);
    }).observe({ type: 'resource' });
  }
  reconcile().catch(() => {});
})();
